module.exports = __webpack_public_path__ + "img/lens-174-plus-06.bc6f057c.png";